import { useState } from "react";
import AppShell from "@/components/AppShell";
import { PageHead } from "@/components/Brand";
import { AdminOverview } from "@/components/admin/AdminOverview";
import { AdminSafety } from "@/components/admin/AdminSafety";
import { AdminPeople } from "@/components/admin/AdminPeople";
import { AdminOverseas } from "@/components/admin/AdminOverseas";
import { AdminAccess } from "@/components/admin/AdminAccess";
import { AdminData } from "@/components/admin/AdminData";
import { AdminAudit } from "@/components/admin/AdminAudit";
import { AdminFeedback } from "@/components/admin/AdminFeedback";

const SECTIONS = [
  ["overview", "Overview", AdminOverview], ["safety", "Safety alerts", AdminSafety], ["feedback", "Feedback", AdminFeedback], ["people", "People and sessions", AdminPeople], ["overseas", "Outside New Zealand", AdminOverseas],
  ["access", "Access and security", AdminAccess], ["data", "Data management", AdminData], ["audit", "Audit and governance", AdminAudit],
];

export default function AdminPortal() {
  const [tab, setTab] = useState("overview");
  const [, , Current] = SECTIONS.find(([k]) => k === tab);
  return (
    <AppShell wide>
      <PageHead eyebrow="Admin" title="Looking after AHU" />
      <div className="grid gap-6 lg:grid-cols-[220px_1fr]">
        <nav className="flex lg:flex-col gap-2 overflow-x-auto pb-2 lg:pb-0 lg:sticky lg:top-24 lg:self-start" data-testid="admin-nav">
          {SECTIONS.map(([k, l]) => (
            <button key={k} onClick={() => setTab(k)} data-testid={`admin-tab-${k}`}
              className={`whitespace-nowrap text-left rounded-full lg:rounded-xl px-4 py-2 lg:py-2.5 text-sm border ${tab === k ? "bg-charcoal border-charcoal text-alabaster" : "bg-white border-rule text-charcoal hover:border-charcoal/40"}`}
              style={{ transition: "background-color .3s ease, border-color .3s ease, color .3s ease" }}>{l}</button>
          ))}
        </nav>
        <div className="min-w-0" key={tab}><Current go={setTab} /></div>
      </div>
    </AppShell>
  );
}
